<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UWU2Qr/images/cover.jpg?1685327174425" alt="This image is the cover for the book Emblem of Faith Untouched, Library of Religious Biography (LRB)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Emblem of Faith Untouched, Library of Religious Biography (LRB)
      </h1>
      <p class="bookDescription body article font2">
        <p> <i>Relates one of the most remarkable lives in the tumultuous English Reformation</i><br/><br/> Thomas Cranmer (1489–1556) was the first Anglican Archbishop of Canterbury, the author of the Book of Common Prayer, and a central figure in the English Protestant Reformation. Few theologians have led such an eventful life: Cranmer helped Henry VIII break with the pope, pressed his vision of the Reformation through the reign of Edward VI, was forced to recant under Queen Mary, and then dramatically withdrew his recantations before being burned alive.<br/><br/> This lively biography by Leslie Williams narrates Cranmer's life from the beginning, through his education and history with the monarchy, to his ecclesiastical trials and eventual martyrdom. Williams portrays Cranmer's ongoing struggle to reconcile his two central loyalties—allegiance to the crown and fidelity to the Reformation faith—as she tells his fascinating life story.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Leslie Winfield Williams
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6baf20f0